import moment from "moment";

/**
 *
 * @param {*} t
 * @return {*} 
 * @status no delete
 */
const PasswordValidator = (t) => {
  moment.locale("es");
  let regexs = {
    passwordRegex: new RegExp(
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[.@#$%^&*!_-])[A-Za-z\d!@#$%^&*._-]{10,16}$/
    )
  };

  let validators = {
    passwordValidator: (value) => {
      if (value !== "" && value !== undefined) {
        if (value.length > 0) {
          return regexs.passwordRegex.test(value)
            ? ""
            : `${t("passwordValidator")}. ${t("loginView.passwordTooltipDesc1")}, ${t("loginView.passwordTooltipDesc2")}, ${t("loginView.passwordTooltipDesc3")}, ${t("loginView.passwordTooltipDesc4")}`
        }
      }
    }
  };
  return validators;
};

export default PasswordValidator;
